import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import { toast, ToastContainer } from 'react-toastify';

import { WithDbId } from '../../../../../adl-gen/common/db';
import { TrainingOffering } from '../../../../../adl-gen/totalinteraction/futurefit/db';
import { TrainingOfferingData } from '../../../../../adl-gen/totalinteraction/futurefit/frontend';
import { Route } from '../../../../../routing/app-routes';
import { SkillTrainingOfferingChange, TrainingOfferingStore } from '../../../../stores';
import { toastOptions } from '../../../common/form';
import { TrainingOfferingEditor } from '../../editors/training-offering-editor/training-offering-editor';
import { TrainingOfferingListEntry } from '../../lists/training-offering-lists/training-offering-list-view';

interface TrainingOfferingFormProps {
  item?: TrainingOfferingListEntry;
  data: TrainingOfferingData;
  store: TrainingOfferingStore;
  // TODO temp for skill nav links in assigned skill list
  navigateTo(route: Route): void;
  onCancel(): void;
}

@observer
export class TrainingOfferingForm extends React.Component<TrainingOfferingFormProps> {
  @observable skillTrainingOfferingChangeList: SkillTrainingOfferingChange[] = [];

  onCreate = async (item: TrainingOffering): Promise<void> => {
    const { onCancel, store } = this.props;

    const toastId = toast.loading('Please wait...', { ...toastOptions, autoClose: 3000 });
    try {
      const offeringId = await store.create(item);

      toast.dismiss(toastId);
      toast.success(`Training Offering ${item.title} with id ${offeringId} created.`, {
        ...toastOptions,
        onClose: onCancel,
        autoClose: 3000
      });
    } catch (e) {
      toast.dismiss(toastId);
      toast.error(`Training Offering ${item.title} create failed: ${(e as Error).message}`, {
        ...toastOptions,
        onClose: onCancel
      });
    }
  };

  onUpdate = async (item: WithDbId<TrainingOffering>, skillUpdates: SkillTrainingOfferingChange[]): Promise<void> => {
    const { onCancel, store } = this.props;

    const toastId = toast.loading('Please wait...', { ...toastOptions, autoClose: 3000 });
    try {
      await store.update(item);
      await store.updateSkillTrainingOfferings(skillUpdates);

      toast.dismiss(toastId);
      toast.success(`Training Offering ${item.value.title} updated.`, {
        ...toastOptions,
        onClose: onCancel,
        autoClose: 3000
      });
    } catch (e) {
      toast.dismiss(toastId);
      toast.error(`Training Offering ${item.value.title} update failed: ${(e as Error).message}`, {
        ...toastOptions,
        onClose: onCancel
      });
    }
  };

  @action
  onCancel = () => {
    this.props.onCancel();
  };

  renderContent = () => {
    const { data, item, navigateTo, store } = this.props;
    if (
      item // && mode === "update"
    ) {
      return (
        <TrainingOfferingEditor
          item={item}
          data={data}
          store={store}
          onCancel={this.onCancel}
          onCreate={this.onCreate}
          onUpdate={this.onUpdate}
          applicationRole={store.isSuperUser ? 'super' : 'client-admin'}
          navigateTo={navigateTo}
        />
      );
    } else {
      return (
        <TrainingOfferingEditor
          data={data}
          store={store}
          onCancel={this.onCancel}
          onCreate={this.onCreate}
          onUpdate={this.onUpdate}
          applicationRole={store.isSuperUser ? 'super' : 'client-admin'}
          navigateTo={navigateTo}
        />
      );
    }
  };

  render() {
    return (
      <React.Fragment>
        {this.renderContent()}
        <ToastContainer newestOnTop />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/ui/components/forms/training-offering-form/training-offering-form.tsx